export const CHECK_RESTAURANT_OPERATION_SERVICE = "CHECK_RESTAURANT_OPERATION_SERVICE";
export const GET_RESTAURANTS_BASED_ON_CATEGORY = "GET_RESTAURANTS_BASED_ON_CATEGORY";
export const GET_RESTAURANTS_CATEGORIES = "GET_RESTAURANTS_CATEGORIES";
